function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M58.0251 10.9211L55.4679 13.4216M1.76758 33.7833H5.42066H1.76758ZM34.6453 1.6333V5.20553V1.6333ZM63.87 33.7833H67.5231H63.87ZM11.2656 10.9211L13.8228 13.4216L11.2656 10.9211Z",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.6861 48.0719C20.6192 45.8227 18.3538 42.6868 17.2107 39.1086C16.0677 35.5304 16.1049 31.6912 17.3172 28.1348C18.5295 24.5785 20.8554 21.4852 23.9653 19.2933C27.0753 17.1014 30.8117 15.9219 34.6453 15.9219C38.4789 15.9219 42.2153 17.1014 45.3253 19.2933C48.4353 21.4852 50.7611 24.5785 51.9734 28.1348C53.1857 31.6912 53.2229 35.5304 52.0799 39.1086C50.9368 42.6868 48.6714 45.8227 45.6046 48.0719C44.1783 49.4525 43.1044 51.1421 42.4697 53.0038C41.8351 54.8656 41.6576 56.8473 41.9515 58.7886C41.9515 60.6834 41.1817 62.5006 39.8115 63.8405C38.4414 65.1803 36.583 65.9331 34.6453 65.9331C32.7076 65.9331 30.8492 65.1803 29.4791 63.8405C28.1089 62.5006 27.3391 60.6834 27.3391 58.7886C27.633 56.8473 27.4555 54.8656 26.8209 53.0038C26.1862 51.1421 25.1123 49.4525 23.6861 48.0719",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M26.2432 51.644H43.0473",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgInnovation = function SvgInnovation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 67,
    viewBox: "0 0 69 67",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInnovation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/innovation.cc6d89ed.svg";
export { ForwardRef as ReactComponent };